import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { buildXAuthStartUrl } from '../../utils/xAuth';
import '../GoogleAuthButton/style.css';
import './style.css';

function XAuthButton({ returnUrl, source = 'login' }) {
	const userActions = useSelector((state) => state.userActions);
	const [localError, setLocalError] = useState('');
	const xAuthError = userActions?.xAuthError ? userActions?.message?.message || userActions?.message : '';
	const isLoading = Boolean(userActions?.isLoading);

	const handleClick = () => {
		try {
			setLocalError('');
			window.location.href = buildXAuthStartUrl(returnUrl, source);
		} catch (error) {
			setLocalError('X sign-in is currently unavailable.');
		}
	};

	return (
		<div className='googleAuthSection'>
			<div className={`xAuthButtonWrap${isLoading ? ' is-loading' : ''}`}>
				<button type='button' className='xAuthButton' onClick={handleClick} disabled={isLoading}>
					<span className='xAuthButtonContent'>
						<svg viewBox='0 0 24 24' aria-hidden='true' className='xAuthButtonLogo'>
							<path
								fill='currentColor'
								d='M18.244 2H21.5l-7.113 8.13L22.75 22h-6.548l-5.127-6.711L5.203 22H1.945l7.607-8.694L1.5 2h6.714l4.634 6.18L18.244 2Zm-1.141 18.05h1.805L7.227 3.847H5.289L17.103 20.05Z'
							/>
						</svg>
						<span className='xAuthButtonLabel'>Continue with X</span>
					</span>
				</button>
				{isLoading ? <div className='googleAuthLoadingOverlay' aria-live='polite'>Redirecting...</div> : null}
			</div>
			{localError || xAuthError ? <div className='googleAuthError'>{localError || xAuthError}</div> : null}
		</div>
	);
}

export default XAuthButton;
